export enum EmailRestrictionEnum {
  List = 'list',
  Domains = 'domains'
}
